import styled from '@emotion/styled';

import { HubspotFormBlock } from '@/components/blocks/hubspotFormBlock';
import { PullQuote } from '@/components/common/PullQuote';
import { WistiaSection } from '@/components/common/WistiaComponents/WistiaSection';
import { CodeSnippet } from '@/components/page/blog/CodeSnippet';
import { Block } from '@/components/page/case-study/Body/Block';
import {
  HtmlContainer,
  HubspotBlockContainer,
  PullQuoteContainer,
  PullStatContainer,
} from '@/components/page/case-study/Body/Body.styles';
import { StyledImage } from '@/components/page/case-study/Body/StyledImage';
import { PullStat } from '@/components/page/case-study/PullStat';

import type { SanityCaseStudyType } from '@/types/sanity';

type PostBodyProps = SanityCaseStudyType['postBody'];

export const PostBody = (postBody: PostBodyProps) => {
  return <PostBodyContainer>{renderPostBody(postBody)}</PostBodyContainer>;
};

const renderPostBody = (postBody: PostBodyProps) => {
  const components = Object.keys(postBody).map((key) => {
    switch (postBody[key]._type) {
      case 'block':
        return <Block {...postBody[key]} />;
      case 'singleImage':
        return <StyledImage {...postBody[key]} />;
      case 'wistiaPopover': {
        return (
          <VideoContainer>
            <WistiaSection {...postBody[key]} />
          </VideoContainer>
        );
      }
      case 'pullQuote':
        return (
          <PullQuoteContainer>
            <PullQuote {...postBody[key]} />
          </PullQuoteContainer>
        );
      case 'pullStat':
        return (
          <PullStatContainer>
            <PullStat {...postBody[key]} />
          </PullStatContainer>
        );
      case 'blogHTMLField':
        return (
          <HtmlContainer>
            <CodeSnippet {...postBody[key]} />
          </HtmlContainer>
        );
      case 'hubspotFormBlock':
        return (
          <HubspotBlockContainer>
            <HubspotFormBlock {...postBody[key]} />
          </HubspotBlockContainer>
        );
    }
  });
  return components;
};

const VideoContainer = styled.div`
  padding-top: var(--space-block-lg);
`;

const PostBodyContainer = styled.div`
  margin-top: 0;

  > :last-child {
    padding-bottom: 0;
  }
`;
